<!--
 * @Descripttion:
 * @Author: 凌伟延
 * @Date: 2019-12-03 14:17:47
 -->
<template>
  <div id='app'>
    <copy-right class='copyright'></copy-right>
    <router-view />
  </div>
</template>

<script>
import CopyRight from '@/components/copyRight/CopyRight'
export default {
  components: {
    CopyRight
  },
  name: 'App'
}
</script>

<style lang='scss'>
html {
  height: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-height: 100%;
  height: 100%;
}
.copyright {
  width: 200px;
  left: -110px;
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/App.vue